var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3385_37358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.0014C4.91247 1.00597 4.70985 1.02551 4.54601 1.10899C4.35785 1.20487 4.20487 1.35785 4.10899 1.54601C4.02551 1.70985 4.00597 1.91247 4.0014 2.25M9.75 1.0014C10.0875 1.00597 10.2902 1.02551 10.454 1.10899C10.6422 1.20487 10.7951 1.35785 10.891 1.54601C10.9745 1.70985 10.994 1.91247 10.9986 2.24999M10.9986 6.74999C10.994 7.08752 10.9745 7.29015 10.891 7.45399C10.7951 7.64215 10.6422 7.79513 10.454 7.89101C10.2902 7.97449 10.0875 7.99403 9.75 7.9986M11 4V5M7.00003 1H7.99998M2.6 11H6.4C6.96005 11 7.24008 11 7.45399 10.891C7.64215 10.7951 7.79513 10.6422 7.89101 10.454C8 10.2401 8 9.96005 8 9.4V5.6C8 5.03995 8 4.75992 7.89101 4.54601C7.79513 4.35785 7.64215 4.20487 7.45399 4.10899C7.24008 4 6.96005 4 6.4 4H2.6C2.03995 4 1.75992 4 1.54601 4.10899C1.35785 4.20487 1.20487 4.35785 1.10899 4.54601C1 4.75992 1 5.03995 1 5.6V9.4C1 9.96005 1 10.2401 1.10899 10.454C1.20487 10.6422 1.35785 10.7951 1.54601 10.891C1.75992 11 2.03995 11 2.6 11Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3385_37358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b9ef6cbf1b43a508cac375d6ddcbf7a6.svg";
export { ForwardRef as ReactComponent };